import React from 'react';
import { classNames } from 'utils';

export default class SectionGroup extends React.PureComponent {
  render() {
    const { className, children } = this.props;

    return (
      <div className={classNames('view-body-section-group', className)}>
        {children}
      </div>
    );
  }
}
